/**
 * Pesquisa de satisfação / NPS (A27).
 *
 * O modelo e o KPI existiam; nada os alimentava. Estes são os endpoints
 * que fecham o ciclo: a equipe lê as respostas, registra a nota colhida
 * na conversa e reenvia o link quando o cliente pede.
 */

const PREFIXO = "/api/comercial/satisfacoes";

export function listarSatisfacoes(request, params = {}, opcoes = {}) {
  const usp = new URLSearchParams();
  if (params.cliente) usp.set("cliente", params.cliente);
  if (params.pedido) usp.set("pedido", params.pedido);
  if (params.respondidas != null) usp.set("respondidas", String(params.respondidas));
  const qs = usp.toString();
  return request(qs ? `${PREFIXO}?${qs}` : PREFIXO, opcoes);
}

/** Resumo do NPS do período — o número que o gestor lê. */
export function obterResumoNps(request, { inicio, fim } = {}, opcoes = {}) {
  const usp = new URLSearchParams();
  if (inicio) usp.set("inicio", inicio);
  if (fim) usp.set("fim", fim);
  const qs = usp.toString();
  return request(qs ? `/api/comercial/nps?${qs}` : "/api/comercial/nps", opcoes);
}

/** Nota que o cliente deu por telefone, no WhatsApp, na obra. */
export function registrarSatisfacao(request, { cliente, nota, comentario, pedido }) {
  return request(PREFIXO, {
    method: "POST",
    body: JSON.stringify({ cliente, nota, comentario, pedido }),
  });
}

/**
 * Pede o link da pesquisa para reenviar ao cliente.
 *
 * O token não vem nas listagens de propósito (C2) — quem tem o link
 * responde no lugar do cliente. Aqui o pedido fica auditado.
 */
export function copiarLinkSatisfacao(request, id) {
  return request(`${PREFIXO}/${id}/copiar-link`, { method: "POST" });
}

export const FAIXA_NPS = {
  Promotor: "success",
  Neutro: "warning",
  Detrator: "danger",
  "Sem resposta": "neutral",
};
